import { useNavigate } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import CreateCustomerForm from "features/storages/customers/createCustomerForm"
import useCustomers from "hooks/useCustomers"
import useStorages from "hooks/useStorages"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import RightSidebar from "components/sidebar/right/RightSidebar"
import PageTitle from "features/navigation/pageTitle"
import { paramGuardStorage } from "@/utils/paramGuard"
import { FormStatus } from "@/types"

const CreateCustomer = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const { targetStorageDocId: storageId } = useTargetStorage()

    const {
        customersStatus
    } = useCustomers({ storageId })

    const { 
        storage,
        storageStatus,
        isCustomersEnabled
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (!paramGuardStorage({storageId, storage, storageStatus, navigate})) {
        return <></>
    }
    const safeStorageId = storageId!;

    // Redirect if customers are disabled for this storage
    if (!isCustomersEnabled()) {
        navigate(`/storage`);
        return <></>;
    }

    const onSuccess = (customerId: string) => {
        navigate(`/storage/customers/${customerId}`)
    }

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleCreateCustomer')} />
            <CreateCustomerForm storageId={safeStorageId} onSuccess={onSuccess} />
            <RightSidebar />
        </>
    )

}

export default CreateCustomer
